import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'
import LoginPage from './pages/LoginPage'
import ProjectsPage from './pages/ProjectsPage'
import ProjectDetailsPage from './pages/ProjectDetailsPage'
import SwipeModePage from './pages/SwipeModePage'
import UnifiedHistoryPage from './pages/UnifiedHistoryPage'
import EarningsPage from './pages/EarningsPage'
import ParserSettingsPage from './pages/ParserSettingsPage'
import AutoLoadHistoryPage from './pages/AutoLoadHistoryPage'
import VDLParsingReportPage from './pages/VDLParsingReportPage'
import MainLayout from './components/Layout/MainLayout'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import { useAuthStore } from './stores/authStore'

function App() {
  const { isAuthenticated } = useAuthStore()

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Routes>
        {/* * Public routes */}
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/projects" replace /> : <LoginPage />} 
        />

        {/* * Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:projectId/sources" element={<ProjectDetailsPage />} />
            <Route path="/projects/:projectId/sources/swipe" element={<SwipeModePage />} />
            <Route path="/history" element={<UnifiedHistoryPage />} />
            <Route path="/earnings" element={<EarningsPage />} />
            <Route path="/settings" element={<ParserSettingsPage />} />
            <Route path="/auto-load" element={<AutoLoadHistoryPage />} />
            <Route path="/reports/vdl-parsing" element={<VDLParsingReportPage />} />
            <Route path="/" element={<Navigate to="/projects" replace />} />
          </Route>
        </Route>

        {/* * Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default App

